import { useMemo } from 'react';

import { TournamentStatus } from '@repo/common-types';

const useTournamentStatusColor = (status: string) => {
  const statusColor = useMemo(() => {
    switch (status) {
      case TournamentStatus.COMPLETED:
        return 'primary';
      case TournamentStatus.CREATED:
        return 'success';
      case TournamentStatus.CANCELLED:
        return 'danger';
      case TournamentStatus.RUNNING:
        return 'primary';
      case TournamentStatus.PAUSED:
        return 'warning';
      case TournamentStatus.BREAK:
        return 'warning';
      case TournamentStatus.INITIALIZING:
        return 'warning';
      default:
        return 'primary';
    }
  }, []);

  return statusColor;
};

export default useTournamentStatusColor;
